import styled from "styled-components";

const ConsentHeading = styled.p`
    margin-top: 0.5em;
`;

export default ConsentHeading;